module.exports = __webpack_public_path__ + "img/epic.1a0d7f31.svg";